import React, { useEffect, useState } from 'react';
import { dashboardService } from '../services/api';
import { StatCard, Alert, Loading, PageHeader } from '../components/UI';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { Package, FileText, DollarSign, Truck, MapPin, AlertTriangle } from 'lucide-react';

const MONTHS = ['Jan','Fev','Mar','Abr','Mai','Jun','Jul','Ago','Set','Out','Nov','Dez'];

export default function Dashboard() {
  const [data, setData] = useState(null);
  const [revenue, setRevenue] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      dashboardService.get(),
      dashboardService.reportsRevenue(new Date().getFullYear()),
    ]).then(([d, r]) => {
      setData(d.data);
      const chartData = Object.entries(r.data).map(([m, v]) => ({
        name: MONTHS[parseInt(m) - 1],
        Receita: v.receita,
        Despesa: v.despesa,
      }));
      setRevenue(chartData);
    }).finally(() => setLoading(false));
  }, []);

  if (loading) return <Loading />;
  if (!data) return null;

  const fmt = (v) => `R$ ${Number(v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`;

  return (
    <>
      <PageHeader title="Dashboard" />
      <div className="page-content">
        {data.alerts?.map((a, i) => (
          <Alert key={i} type={a.type === 'danger' ? 'danger' : 'warning'}>
            {a.message}
          </Alert>
        ))}

        <div className="stats-grid">
          <StatCard icon={<Package size={22} />} value={data.total_assets} label="Total de Banheiros" color="#0ea5e9" bg="#e0f2fe" />
          <StatCard icon={<Package size={22} />} value={data.assets_available} label="Disponíveis" color="#22c55e" bg="#dcfce7" />
          <StatCard icon={<Package size={22} />} value={data.assets_rented} label="Locados" color="#6366f1" bg="#ede9fe" />
          <StatCard icon={<Package size={22} />} value={data.assets_maintenance} label="Em Manutenção" color="#f59e0b" bg="#fef9c3" />
        </div>

        <div className="stats-grid">
          <StatCard icon={<FileText size={22} />} value={data.active_contracts} label="Contratos Ativos" color="#6366f1" bg="#ede9fe" />
          <StatCard icon={<DollarSign size={22} />} value={fmt(data.monthly_revenue)} label="Receita do Mês" color="#22c55e" bg="#dcfce7" />
          <StatCard icon={<DollarSign size={22} />} value={fmt(data.pending_receivables)} label="A Receber" color="#f59e0b" bg="#fef9c3" />
          <StatCard icon={<MapPin size={22} />} value={data.logistics_today} label="Operações Hoje" color="#0ea5e9" bg="#e0f2fe" />
        </div>

        {data.overdue_receivables > 0 && (
          <Alert type="danger">
            <AlertTriangle size={16} />
            {fmt(data.overdue_receivables)} em recebíveis em atraso
          </Alert>
        )}

        <div className="card" style={{ marginTop: 8 }}>
          <div className="card-header"><h2>Receita vs Despesa — {new Date().getFullYear()}</h2></div>
          <div className="card-body">
            <ResponsiveContainer width="100%" height={280}>
              <BarChart data={revenue}>
                <XAxis dataKey="name" tick={{ fontSize: 12 }} />
                <YAxis tick={{ fontSize: 12 }} tickFormatter={(v) => `R$${(v/1000).toFixed(0)}k`} />
                <Tooltip formatter={(v) => fmt(v)} />
                <Legend />
                <Bar dataKey="Receita" fill="#22c55e" radius={[4,4,0,0]} />
                <Bar dataKey="Despesa" fill="#ef4444" radius={[4,4,0,0]} />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </>
  );
}
